import moment from 'moment';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import {
    APPOINTMENT_ACTION,
    APPOINTMENT_DATE_STRING_FORMAT,
    DEFAULT_APPOINTMENT_DURATION_MINUTES,
    MINUTES_PER_HOUR,
    TAppointmentAction,
} from 'src/modules/assistant/constants/actions';
import { createActionHandler } from 'src/modules/assistant/actions/createActionHandler';
import { TCreateAppointmentDraft } from 'src/modules/assistant/actions/types';
import { isFutureDate } from 'src/modules/assistant/helpers/isFutureDate';

const APPOINTMENT_ACTIONS = new Set<string>(Object.values(APPOINTMENT_ACTION));

const getAppointmentAction = (
    draft: TCreateAppointmentDraft
): TAppointmentAction =>
    APPOINTMENT_ACTIONS.has(draft.appointmentAction)
        ? (draft.appointmentAction as TAppointmentAction)
        : APPOINTMENT_ACTION.INFORMATION;

export const createAppointment = createActionHandler<TCreateAppointmentDraft>({
    fields: [
        ['title', 'Assistant.ActionFieldTitle'],
        ['description', 'Assistant.ActionFieldDescription', true],
        ['email', 'Assistant.ActionFieldEmail'],
    ],
    schedulable: true,
    validate: (draft) =>
        Boolean(
            draft.title?.trim() &&
                draft.description?.trim() &&
                draft.email?.trim()
        ) && isFutureDate(draft.scheduledAt),
    execute: (draft, { lead, appointmentActions }) => {
        const store = getDocumentId(lead.store);
        const agent = getDocumentId(lead.agent);
        if (!store || !agent) return false;
        const durationMinutes =
            draft.durationMinutes || DEFAULT_APPOINTMENT_DURATION_MINUTES;
        const startDate = moment(draft.scheduledAt);
        return appointmentActions.createAssistantAppointment({
            title: draft.title,
            description: draft.description,
            action: getAppointmentAction(draft),
            startDate: startDate.toISOString(),
            endDate: startDate
                .clone()
                .add(durationMinutes, 'minutes')
                .toISOString(),
            lead: lead._id,
            email: draft.email,
            customer: lead.name,
            store,
            duration: durationMinutes / MINUTES_PER_HOUR,
            user: agent,
            fechaString: startDate.format(APPOINTMENT_DATE_STRING_FORMAT),
            allDay: false,
            isAssistantGenerated: true,
        });
    },
});
